import { Component, OnInit, SimpleChanges, OnChanges, ChangeDetectorRef, AfterViewInit, OnDestroy, ChangeDetectionStrategy, Input } from '@angular/core';
import { WebView } from '@awesome-cordova-plugins/ionic-webview/ngx';
import { ModalController } from '@ionic/angular';
import { MyApp } from 'src/app/api/helper/app';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { ClickHelper } from 'src/app/api/helper/click-helper';
import { FileHelper } from 'src/app/api/helper/file-helper';
import { UiHelper } from 'src/app/api/helper/ui-helper';
import { Utils } from 'src/app/api/helper/utils';
import { AbfahrtskontrolleEintragVO, AbfahrtskontrolleGruppeVO, BildVO } from 'src/app/api/model/model';
import { CameraHelper } from '../../helper/camera-helper';
import { AppConfig } from 'src/app/api/helper/app.config';
import { AppStorage } from 'src/app/api/helper/app-storage';

const log = new Logger("AbfahrtskontrolleGruppeDetailsComponent");

@Component({
    selector: 'app-abfahrtskontrolle-gruppe-details',
    templateUrl: './abfahrtskontrolle-gruppe-details.component.html',
    styleUrls: ['./abfahrtskontrolle-gruppe-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AbfahrtskontrolleGruppeDetailsComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
    static instance: AbfahrtskontrolleGruppeDetailsComponent;

    @Input() vo: AbfahrtskontrolleGruppeVO;

    isVisible = false;
    alertAktiv = false;
    kameraAktiv = false;

    constructor(
        private cdr: ChangeDetectorRef,
        private webView: WebView,
        private modalController: ModalController,) {

        AbfahrtskontrolleGruppeDetailsComponent.instance = this;
    }

    ngOnChanges(changes: SimpleChanges) {
        log?.debug('ngOnChanges');
    }

    ngOnDestroy(): void {
        log?.debug('ngOnDestroy');
        this.isVisible = false;
        MyApp.loading(false);
    }

    async ngOnInit() {
        log?.debug('ngOnInit');

        this.isVisible = true;
    }

    async ngAfterViewInit() {
        log?.debug('ngAfterViewInit');
    }

    onClose() {
        log?.debug('onClose');
        this.modalController.dismiss(null);
    }

    onAbfahrtskontrollItemChanged(e: Event, eintrag: AbfahrtskontrolleEintragVO, ok: boolean) {
        log?.debug('onAbfahrtskontrollItemChanged ' + eintrag.eintrag.name + ' = ' + ok);

        if (ok) {
            eintrag.ok = !eintrag.ok;
            eintrag.nok = false;
        } else {
            eintrag.ok = false;
            eintrag.nok = !eintrag.nok;
        }

        this.aktualisiereButtonColor(eintrag);

        this.cdr.detectChanges();
    }

    aktualisiereButtonColor(vo: AbfahrtskontrolleEintragVO) {
        if (vo.ok) {
            vo.okButtonColor = 'success';
            vo.nokButtonColor = 'light';
        } else if (vo.nok) {
            vo.okButtonColor = 'light';
            vo.nokButtonColor = 'danger';
        } else {
            vo.okButtonColor = 'light';
            vo.nokButtonColor = 'light';
        }
    }

    async onBildClicked(e: Event, item: AbfahrtskontrolleEintragVO, bild: BildVO) {
        const ok = await UiHelper.confirmJaNein('Bild wirklich löschen?', 'Frage');

        if (ok) {
            const idx = item.bilder.indexOf(bild);

            if (idx > -1) {
                const guid = bild.guid;

                item.bilder.splice(idx, 1);

                await this.updateBilder(item);

                FileHelper.deleteFile(bild.src);
            }

            this.cdr.detectChanges();
        }
    }

    private async updateBilder(vo: AbfahrtskontrolleEintragVO): Promise<void> {
        if (!vo.bilder) {
            vo.bilder = [];
        }

        for (const bild of vo.bilder) {
            let src = bild.bild;

            if (src && src.startsWith('file:')) {
                // Bild ist als Datei gespeichert und es wird hier der Pfad zurückgegeben
                src = this.webView.convertFileSrc(src);
            } else {
                // Bild ist als Base64 hinterlegt
                if (!src.startsWith("data:image/")) {
                    src = 'data:image/jpeg;base64,' + src;
                }
            }

            bild.src = src;
        }
    }


    onFotoAufnehmen(e: Event, vo: AbfahrtskontrolleEintragVO) {
        ClickHelper.click(e, () => this.doFotoAufnehmen(vo));
    }

    async doFotoAufnehmen(vo: AbfahrtskontrolleEintragVO) {
        // imageData is a base64 encoded string
        // this.base64Image = "data:image/jpeg;base64," + imageData;
        this.kameraAktiv = true;

        let filenamePrefix = 'abfahrtskontrolle-' + vo.eintrag.key;

        let pictureSrc = await CameraHelper.takePicture({
            filenamePrefix,
            text: AppConfig.current.einstellungen.FotosTextFahrzeugkontrolle
        });

        if (pictureSrc) {
            log?.debug('pictureSrc', pictureSrc);

            const bild: BildVO = {
                datum: new Date().toISOString(),
                bild: pictureSrc,
                guid: Utils.uuid(),
                src: null
            };

            if (!vo.bilder) {
                vo.bilder = [];
            }

            vo.bilder.push(bild);

            await AppStorage.current.set('bild-' + bild.guid, pictureSrc, false);
        }

        this.updateBilder(vo);

        this.cdr.detectChanges();

        setTimeout(() => {
            this.kameraAktiv = false;
        }, 250);
    }
}
